import { AbstractCollectionDirective } from './abstract-collection.directive';
import { Component } from '@angular/core';

@Component({
  templateUrl: './lidar-detail.component.html',
  styleUrls: ['./ie11-fixes.scss'],
})
export class LidarDetailComponent extends AbstractCollectionDirective {}
